import {Country} from "../../@types/demoCountrySelectorResources.ts";

export const CountrySelectorConfig: Country[] = [
    {
        title: 'lithuania',
        code: 'LT'
    },
    {
        title: 'latvia',
        code: 'LV'
    },
    {
        title: 'estonia',
        code: 'EE'
    },
];
